import * as types from './mutation-types';
import { SEARCH_PARAMS } from './state';

export default {
	[types.STATE_INIT]: state => {
		state.isMmcAdmin = false;
		state.maxCnt = 0;
		state.sumCnt = 0;
		state.resultList = {};
		state.graphList = [];
		state.searchParams = SEARCH_PARAMS();
		state.usePlCdList = []; //사용장소 selectBox
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	}
};
